"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ScheduleScreenStore = require("../../stores/ScheduleScreenStore");

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _MainStore = require("../../stores/MainStore");

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Constants = require("../Constants");

var Constants = _interopRequireWildcard(_Constants);

var _Utility = require("../../utils/Utility");

var Utility = _interopRequireWildcard(_Utility);

var Utils = _interopRequireWildcard(_Utility);

var _SpinButton = require("../generic/SpinButton");

var _SpinButton2 = _interopRequireDefault(_SpinButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RestaurantInfoModal = function (_React$Component) {
    _inherits(RestaurantInfoModal, _React$Component);

    function RestaurantInfoModal(props) {
        _classCallCheck(this, RestaurantInfoModal);

        var _this = _possibleConstructorReturn(this, (RestaurantInfoModal.__proto__ || Object.getPrototypeOf(RestaurantInfoModal)).call(this, props));

        _this.state = {
            locationData: {},
            businessData: {}
        };

        _this.loadLocationMap = _this.loadLocationMap.bind(_this);
        return _this;
    }

    _createClass(RestaurantInfoModal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            var activeLocation = _MainStore2.default.getActiveLocation();
            var businessDetail = _MainStore2.default.getBusinessDetail();

            if (!Utility.isEmptyObj(activeLocation)) {
                this.setState({
                    locationData: activeLocation,
                    businessData: businessDetail
                }, function () {
                    // this.loadLocationMap()
                    _this2.initialize();
                });
            }

            //bootstrap modal show on comp mount.
            $('#restaurantInfoModal').modal('show');
            $("#restaurantInfoModal").on('hidden.bs.modal', function () {
                _this2.props.callBackParent(false);
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            //hide modal if open while unmounting
            if ($('#restaurantInfoModal').hasClass('show')) {
                // The modal is open, so you can hide it
                $('#restaurantInfoModal').modal('hide');
            }
        }
    }, {
        key: "initialize",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var map, activeLocation, position, location, _ref2, Map, _ref3, AdvancedMarkerElement, infowindow, marker;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                activeLocation = _MainStore2.default.getActiveLocation();
                                position = { lat: 0, lng: 0 };


                                if (!Utils.isEmptyObj(activeLocation) && !Utils.isEmptyObj(activeLocation.location)) {
                                    location = activeLocation.location;

                                    position = { lat: location.latitude, lng: location.longitude };
                                }

                                _context.next = 5;
                                return google.maps.importLibrary("maps");

                            case 5:
                                _ref2 = _context.sent;
                                Map = _ref2.Map;
                                _context.next = 9;
                                return google.maps.importLibrary("marker");

                            case 9:
                                _ref3 = _context.sent;
                                AdvancedMarkerElement = _ref3.AdvancedMarkerElement;
                                map = new google.maps.Map(document.getElementById('gMapCanvas'), {
                                    zoom: 7,
                                    center: position,
                                    mapTypeId: google.maps.MapTypeId.ROADMAP
                                });
                                infowindow = new google.maps.InfoWindow();
                                marker = new google.maps.Marker({
                                    position: position,
                                    map: map,
                                    visible: true
                                });


                                google.maps.event.addListener(marker, 'click', function (marker, i) {
                                    return function () {
                                        infowindow.setContent(activeLocation.name);
                                        infowindow.open(map, marker);
                                    };
                                }(marker, i));

                                this.resizeMap();

                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function initialize() {
                return _ref.apply(this, arguments);
            }

            return initialize;
        }()
    }, {
        key: "resizeMap",
        value: function resizeMap() {
            if (typeof map == "undefined") return;
            setTimeout(function () {
                resizingMap();
            }, 400);
        }
    }, {
        key: "resizingMap",
        value: function resizingMap() {
            if (typeof map == "undefined") return;
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        }
    }, {
        key: "loadLocationMap",
        value: function loadLocationMap() {

            // let businessLocations = this.state.BusinessLocations;
            var bLocation = this.state.locationData;

            var locations = [bLocation.name, bLocation.location.latitude, bLocation.location.longitude, "1"];

            var Latitude = bLocation.location.latitude;
            var Longitude = bLocation.location.longitude;

            var map = new google.maps.Map(document.getElementById('gMapCanvas'), {
                zoom: 7,
                center: new google.maps.LatLng(bLocation.location.latitude, bLocation.location.longitude),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            var infowindow = new google.maps.InfoWindow();

            var marker, i;

            for (i = 0; i < locations.length; i++) {
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                    map: map,
                    visible: true
                });

                google.maps.event.addListener(marker, 'click', function (marker, i) {
                    return function () {
                        infowindow.setContent(locations[i][0]);
                        infowindow.open(map, marker);
                    };
                }(marker, i));
            }

            setTimeout(function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(new google.maps.LatLng(Latitude, Longitude));
            }, 300);
        }
    }, {
        key: "getWeeklyOpenHours",
        value: function getWeeklyOpenHours() {

            var locationData = this.state.locationData;

            // get date time based on the location
            var dateTime = _MainStore2.default.getCurrentDateTime();
            var weeklyOpenHours = Utils.getOpenHoursString(locationData.openHours, dateTime);

            var dataArray = [];
            var key = void 0;
            var currentDay = Utils.getCurrentDayShort(dateTime).toUpperCase();

            var i = 0;
            for (key in weeklyOpenHours) {

                var className = i == 0 ? "pl-0" : "pl-4";

                var dailyOpenHours = weeklyOpenHours[key];

                var todaySpan = currentDay == key ? _react2.default.createElement(
                    "span",
                    { className: "badge badge-success" },
                    " TODAY "
                ) : null;

                var dailyOpenKey = void 0;

                var rowData = "";
                if (dailyOpenHours) {
                    for (dailyOpenKey in dailyOpenHours) {
                        var dailyOpenKeyValue = dailyOpenHours[dailyOpenKey];

                        if (dailyOpenKeyValue && dailyOpenKeyValue != "CLOSED") {
                            var startTime = dailyOpenHours[dailyOpenKey][0];
                            var endTime = dailyOpenHours[dailyOpenKey][1];

                            var sprater = dailyOpenKey != 0 ? " | " : "";

                            var startEndTime = sprater + startTime + " - " + endTime;
                            rowData += startEndTime;
                        } else {
                            rowData += dailyOpenKeyValue;
                        }
                    }
                }

                rowData = _react2.default.createElement(
                    "tr",
                    { key: key },
                    _react2.default.createElement(
                        "td",
                        { className: "day-name text-secondary pl-4" },
                        key
                    ),
                    _react2.default.createElement(
                        "td",
                        { className: "text-secondary pl-4" },
                        rowData,
                        " ",
                        todaySpan,
                        " "
                    )
                );
                dataArray.push(rowData);

                // increase the i value
                i++;
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                dataArray
            );
        }
    }, {
        key: "getDeliveryOpenHours",
        value: function getDeliveryOpenHours() {
            var locationData = this.state.locationData;

            // get date time based on the location
            var dateTime = _MainStore2.default.getCurrentDateTime();

            var weeklyOpenHours = Utils.getOpenHoursString(locationData.deliveryHours, dateTime);

            var dataArray = [];
            var key = void 0;
            var currentDay = Utils.getCurrentDayShort(dateTime).toUpperCase();

            var i = 0;
            for (key in weeklyOpenHours) {

                var className = i == 0 ? "pl-0" : "pl-4";

                var dailyOpenHours = weeklyOpenHours[key];

                var todaySpan = currentDay == key ? _react2.default.createElement(
                    "span",
                    { className: "badge badge-success" },
                    " TODAY "
                ) : null;

                var dailyOpenKey = void 0;

                var rowData = "";
                if (dailyOpenHours) {
                    for (dailyOpenKey in dailyOpenHours) {
                        var dailyOpenKeyValue = dailyOpenHours[dailyOpenKey];

                        if (dailyOpenKeyValue && dailyOpenKeyValue != "CLOSED") {
                            var startTime = dailyOpenHours[dailyOpenKey][0];
                            var endTime = dailyOpenHours[dailyOpenKey][1];

                            var sprater = dailyOpenKey != 0 ? " | " : "";

                            var startEndTime = sprater + startTime + " - " + endTime;
                            rowData += startEndTime;
                        } else {
                            rowData += dailyOpenKeyValue;
                        }
                    }
                }

                rowData = _react2.default.createElement(
                    "tr",
                    { key: i + key },
                    _react2.default.createElement(
                        "td",
                        { className: "day-name text-secondary pl-4" },
                        key
                    ),
                    _react2.default.createElement(
                        "td",
                        { className: "text-secondary pl-4" },
                        rowData,
                        " "
                    )
                );
                dataArray.push(rowData);

                // increase the i value
                i++;
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                dataArray
            );
        }
    }, {
        key: "render",
        value: function render() {

            var locationData = this.state.locationData;
            var deliveryHours = locationData.deliveryHours;

            var phoneNumber = "";
            var address = "";
            var locationName = "";

            if (!Utility.isEmptyObj(locationData)) {
                // Location name
                locationName = locationData.name;
                // Phone number
                phoneNumber = Utility.formatPhoneNumber(locationData.phoneNumber);
                var addressString1 = locationData.addLine1;
                // Address
                var addressString2 = locationData.city + ", " + locationData.state + " " + locationData.zipCode;
                address = addressString1.toUpperCase() + ", " + addressString2.toUpperCase();
            }

            var businessData = this.state.businessData;

            var website = "";
            if (!Utility.isEmptyObj(businessData)) {

                if (!Utility.isEmpty(locationData.url)) {
                    website = locationData.url;
                    //check if https is present
                    //if not then add on website
                    if (website.indexOf('https') === -1 && website.indexOf('http') === -1) {
                        website = "https://" + website;
                    }
                }
            }

            return _react2.default.createElement(
                "div",
                {
                    className: "modal fade",
                    id: "restaurantInfoModal", tabIndex: "-1", role: "dialog",
                    "aria-labelledby": "modalLabel", "aria-hidden": "true",
                    "data-keyboard": "false", "data-backdrop": "static"
                },
                _react2.default.createElement(
                    "div",
                    { className: "modal-dialog modal-lg modal-dialog-centered", role: "document" },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-content" },
                        _react2.default.createElement(
                            "div",
                            { className: "modal-header" },
                            _react2.default.createElement(
                                "h5",
                                { className: "px-4 modal-title", id: "edit-profile" },
                                "Restaurant Info"
                            ),
                            _react2.default.createElement(
                                "button",
                                { type: "button", className: "close", "data-dismiss": "modal",
                                    "aria-label": "Close" },
                                _react2.default.createElement(
                                    "span",
                                    { "aria-hidden": "true" },
                                    "\xD7"
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "modal-body" },
                            _react2.default.createElement(
                                "div",
                                { className: "tab-pane mb-2", id: "pills-restaurant-info" },
                                _react2.default.createElement(
                                    "div",
                                    { id: "restaurant-info", className: "bg-white rounded px-4 pr-4 mb-4" },
                                    _react2.default.createElement(
                                        "div",
                                        { className: "address-map float-right ml-5" },
                                        _react2.default.createElement(
                                            "div",
                                            { className: "mapouter" },
                                            _react2.default.createElement("div", { id: "gMapCanvas",
                                                className: !Utils.isEmptyObj(deliveryHours) ? "gMapContainer" : "gMapCanvas"
                                            })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        "h5",
                                        { className: "mb-2" },
                                        locationName
                                    ),
                                    _react2.default.createElement(
                                        "p",
                                        { className: "mb-2 text-secondary" },
                                        address
                                    ),
                                    _react2.default.createElement(
                                        "p",
                                        { className: "mb-2 text-black" },
                                        _react2.default.createElement("i", {
                                            className: "icofont-phone-circle text-primary" }),
                                        _react2.default.createElement(
                                            "span",
                                            { className: "ml-2" },
                                            phoneNumber
                                        )
                                    ),
                                    !Utils.isEmpty(website) ? _react2.default.createElement(
                                        "p",
                                        { className: "mb-2 text-black" },
                                        _react2.default.createElement("i", { className: "icofont-external-link text-primary" }),
                                        _react2.default.createElement(
                                            "a",
                                            {
                                                className: "ml-2", target: "_blank",
                                                href: website,
                                                tabIndex: 0
                                            },
                                            website
                                        )
                                    ) : null,
                                    _react2.default.createElement(
                                        "span",
                                        null,
                                        _react2.default.createElement(
                                            "p",
                                            { className: "mb-0 text-black font-weight-bold" },
                                            _react2.default.createElement("i", {
                                                className: "icofont-clock-time text-primary" }),
                                            _react2.default.createElement(
                                                "span",
                                                { className: "ml-2" },
                                                "Open Hours"
                                            )
                                        ),
                                        _react2.default.createElement(
                                            "table",
                                            null,
                                            _react2.default.createElement(
                                                "tbody",
                                                null,
                                                this.getWeeklyOpenHours()
                                            )
                                        )
                                    ),
                                    !Utils.isEmptyObj(deliveryHours) ? _react2.default.createElement(
                                        "span",
                                        null,
                                        _react2.default.createElement(
                                            "p",
                                            { className: "mb-0 mt-2 text-black font-weight-bold" },
                                            _react2.default.createElement("i", {
                                                className: "icofont-delivery-time text-primary mr-2" }),
                                            "Delivery Hours"
                                        ),
                                        _react2.default.createElement(
                                            "table",
                                            null,
                                            _react2.default.createElement(
                                                "tbody",
                                                null,
                                                this.getDeliveryOpenHours()
                                            )
                                        )
                                    ) : null
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RestaurantInfoModal;
}(_react2.default.Component);

exports.default = RestaurantInfoModal;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/RestaurantInfoModal.jsx
// module id = 536
// module chunks = 0